// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"xp-z","slideIn":"yp-z"};